var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"follow-page"},[(!this.isImage)?_c('img',{staticClass:"img-page",attrs:{"src":require("@/assets/WechatIMG472.jpg"),"alt":""}}):_c('img',{staticClass:"img-page",attrs:{"src":require("@/assets/WechatIMG475.jpg"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"page-txt"},[_vm._v("长按二维码关注公众号")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64f75ad0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/loginPage/followPage.vue
// module id = null
// module chunks = 